import {
  loadActiveAgentConversation,
  setActiveTab,
  setSidebarFocus,
  setTabDraft,
  type AppDispatch,
  type RootState
} from '@axilon-apps/domains-ontology-ui-state'

export const MAKE_ARTIFACT_LIVE_PROMPT =
  'Make the open artifact live: switch its time bounds to a relative window and add pollMs so it keeps refreshing.'

export function draftMakeLiveTurn(conversationId: string) {
  return async (dispatch: AppDispatch, getState: () => RootState): Promise<boolean> => {
    if (getState().agentOrchestrator.tabs[conversationId] === undefined) {
      await dispatch(loadActiveAgentConversation(conversationId))
    }
    if (getState().agentOrchestrator.tabs[conversationId]?.canContribute === false) {
      return false
    }
    dispatch(setActiveTab({ id: conversationId }))
    dispatch(setTabDraft({ id: conversationId, draft: MAKE_ARTIFACT_LIVE_PROMPT }))
    dispatch(setSidebarFocus({ kind: 'chat', id: conversationId }))
    return true
  }
}
